import type { OccurrenceStatus } from "../types";

export const STATUS_LABELS: Record<OccurrenceStatus, string> = {
  scheduled: "Zaplanowane",
  live: "Trwa",
  ended: "Zakończone",
  cancelled: "Odwołane",
};

const STATUS_CLASSES: Record<OccurrenceStatus, string> = {
  scheduled:
    "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300",
  live: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300",
  ended:
    "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400",
  cancelled:
    "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
};

export function OccurrenceStatusBadge({ status }: { status: OccurrenceStatus }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${STATUS_CLASSES[status]}`}
    >
      {status === "live" && (
        <span className="relative flex h-1.5 w-1.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75" />
          <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-red-600" />
        </span>
      )}
      {STATUS_LABELS[status]}
    </span>
  );
}
